import { LIST_BUCKET } from '@todo/core/list-queries';
import { getPrefetched, prefetchElementId, serializePrefetch } from '@todo/core/static-prefetch';

/**
 * Bakes a list's build-time rows (src/lib/prefetch.ts) into the page as JSON,
 * so useTours / useBoats find them on the client's first render and hydration
 * matches the static HTML. Null when there's no seed (native, or a failed
 * prefetch).
 *
 * A plain function, not a component, because it goes inside <Head>:
 * expo-router's vendored react-helmet-async throws on any child whose `type`
 * is a function, and fails the page's static render (see
 * apps/riviera/src/components/detail/list-seed.tsx, the same helper).
 */
export function seedScript(seedKey: string) {
  const rows = getPrefetched<unknown>(LIST_BUCKET, seedKey);
  if (rows === undefined) return null;

  return (
    <script id={prefetchElementId(LIST_BUCKET, seedKey)} type="application/json">
      {serializePrefetch(rows)}
    </script>
  );
}
